import { isEmpty, isNil, negate } from 'lodash'
import { PaginationOptions } from 'utils-next/types'

export function parsePaginationOptions({ currentPage, limit }: PaginationOptions) {
  return {
    skip: currentPage * limit,
    limit,
  }
}

export function createEntityParser<ApiType, DataType>(transformFn: (data: ApiType) => DataType) {
  return (data: ApiType | ApiType[]) => {
    if (Array.isArray(data)) {
      return data.map(transformFn)
    } else {
      return transformFn(data)
    }
  }
}

export function getUrlWithPathParams(baseUrl: string, ...pathParams: (string | number | undefined)[]): string {
  const nonNullPathParams = pathParams.filter(negate(isNil)) as (string | number)[]
  const normalizedPathParams = nonNullPathParams
    .map((pathParam: string | number) =>
      pathParam
        .toString()
        .replace(/\/+/g, '/')
        .replace(/^\/|\/$/g, '')
    )
    .filter(negate(isEmpty))
  const hasTrailingSlash = baseUrl.slice(-1) === '/'
  const normalizedBaseUrl = hasTrailingSlash ? baseUrl : baseUrl + '/'
  return normalizedBaseUrl.concat(normalizedPathParams.join('/'))
}

// Remove nulls from api petitions
// https://www.youtube.com/watch?v=PSGEjv3Tqo0&feature=youtu.be&t=9m21s
export function normalizeDataForApi(data: any) {
  if (typeof data !== 'object' || data instanceof FormData) {
    return data
  }
  const parsedObject = {}
  const keys = Object.keys(data)
  for (let i = 0, l = keys.length; i < l; i++) {
    const key = keys[i]
    parsedObject[key] = data[key] === null || data[key] === undefined || data[key] === '' ? null : data[key]
  }
  return parsedObject
}

export function emptyStringToUndefined(value: unknown) {
  return value === '' ? undefined : value
}

export function emptyStringToNull(value: unknown) {
  return value === '' ? null : value
}

export enum QueryStatus {
  loading = 'loading',
  idle = 'idle',
  error = 'error',
}

export enum MutationStatus {
  success = 'success',
  loading = 'loading',
  idle = 'idle',
  error = 'error',
}
